<!--
 * @Description: 资金管理等待审核
 * @Author: xu wei
 * @Date: 2020-02-27 17:00:45
 * @LastEditTime: 2020-09-26 09:18:51
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>资金管理</el-breadcrumb-item>
        <el-breadcrumb-item>等待审核</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <ul class="clearfix">
        <li>
          <span class='tit'>商户ID：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" type="number" v-model="tenantId" @input="tenantId=intNumber(tenantId)" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>余额：</span>
          <span class="txtbox">
            <el-input style="width:100px;" type="number" size="small" v-model="ontherecharge" @input="ontherecharge=intNumber(ontherecharge)" placeholder="请输入内容"></el-input> --
            <el-input style="width:100px;" type="number" size="small" v-model="undertherecharge" @input="undertherecharge=intNumber(undertherecharge)" placeholder="请输入内容"></el-input>
          </span>
          <span class="mgl10">
            <el-button size="small" type="primary" @click="()=>{pageIndex=1;getlist();auditInfo();}">查询</el-button>
          </span>
        </li>
      </ul>
    </div>
    <div class="gs_tablebox">
      <div style=" margin-top: 20px;background: #fff;padding: 5px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
        <el-button size="small" type="primary" :disabled="selcetlist.length===0" @click="toggleAgree(true)">审核通过</el-button>
        <el-button size="small" type="danger" :disabled="selcetlist.length===0" @click="dialog.show=true">驳回</el-button>
        <span class='tit' style="float: right;font-size: 14px;padding: 8px;">账户余额总额：<i style="color:red;">{{totalMoney}}</i>元 总手续费：<i style="color:red;">{{chargeMoney}}</i>元</span>
      </div>
      <el-table ref="moduleTable" size="mini" @selection-change="selchange" :data="tableData" border style="width: 100%" stripe>
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="merchantId" label="商户ID" width="70">
        </el-table-column>
        <el-table-column label="商户名/账号">
          <template slot-scope="scope">
            <p>{{scope.row.nickName}}</p>
            <p style="color:#666;">{{scope.row.account}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="applyDate" label="申请时间" width="160">
        </el-table-column>
        <el-table-column prop="serialNumber" label="流水号" width="180">
        </el-table-column>
        <el-table-column prop="realName" label="收款人">
        </el-table-column>
        <el-table-column prop="bankName" label="收款银行">
        </el-table-column>
        <el-table-column label="金额">
          <template slot-scope="scope">
            <span>{{scope.row.amount.toFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="charge" label="手续费">
          <template slot-scope="scope">
            <span>{{scope.row.charge.toFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述">
        </el-table-column>
        <el-table-column prop="completeDate" label="完成时间" width="160">
        </el-table-column>
        <el-table-column prop="name" label="状态" width="100">
          <template slot-scope="scope">
            <span class="stateColor" :class="'color'+scope.row.state">{{scope.row.state|fstate}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 驳回时填写理由 -->
    <el-dialog title="输入拒绝理由并确认" :visible.sync="dialog.show" @close="dialog.textarea=''" custom-class="gs_dialog" width="500px">
      <div>
        <el-input class="gs_textarea" type="textarea" placeholder="请输入内容" v-model="dialog.textarea"></el-input>
        <p class="tr pdb15 pdt15">
          <el-button size="small" type="primary" @click="unagree">确定</el-button>
          <el-button size="small" type="info" @click="dialog.show=false">取消</el-button>
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tenantId: '', // 商户ID
      ontherecharge: '', // 充值金额上
      undertherecharge: '', // 充值金额下
      selcetlist: [], // 列表的多选
      totalMoney: 0, // 账户余额总额
      chargeMoney: 0, // 总手续费
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      tableData: [],
      dialog: {
        show: false,
        textarea: ''
      }
    };
  },
  filters: {
    fstate: function(data) {
      let state = '';
      switch (data) {
        case 0:
          state = '全部';
          break;
        case 1:
          state = '成功';
          break;
        case 2:
          state = '付款中';
          break;
        case 3:
          state = '审核中';
          break;
        case 4:
          state = '待付款';
          break;
        case 5:
          state = '审核失败';
          break;
        case 6:
          state = '拒绝付款';
          break;
      }
      return state;
    }
  },
  methods: {
    // 等待审核列表
    getlist() {
      this.$api.money
        .auditlist({
          MerchantId: this.tenantId === '' ? 0 : parseFloat(this.tenantId),
          MinAmount: this.ontherecharge,
          MaxAmount: this.undertherecharge,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 获取待审核列表统计
    auditInfo() {
      this.$api.money
        .auditStaic()
        .then((data) => {
          if (data.status === 200) {
            this.totalMoney = data.data.totalAmount.toFixed(2);
            this.chargeMoney = data.data.totalCharge.toFixed(2);
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 多选的选项变化时
    selchange(data) {
      this.selcetlist = data.map((item) => {
        return { id: item.id };
      });
    },
    // 审核通过和驳回
    toggleAgree(type) {
      this.$api.money
        .auditWidthdraw({
          managerSettlementIdParameters: this.selcetlist,
          state: type,
          content: this.dialog.textarea
        })
        .then((data) => {
          if (data.status === 200) {
            if (type) {
              this.$messageSuccess('审核通过成功！');
            } else {
              this.$messageSuccess('驳回成功！');
            }
            this.dialog.show = false;
            this.getlist();
            this.auditInfo();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 驳回理由的确定
    unagree() {
      if (this.dialog.textarea === '') {
        this.$messageError('请输入驳回理由');
        return;
      }
      this.toggleAgree(false);
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
      this.auditInfo();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
      this.auditInfo();
    }
  },
  created() {
    this.getlist();
    this.auditInfo();
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
.tableinfo {
  background: #fff;
  padding: 8px 20px;
  table {
    width: 100%;
    color: #272727;
    font-size: 14px;
    td {
      height: 30px;
    }
    .c_3fa396 {
      color: #3fa396;
    }
  }
}
.stateColor {
  display: inline-block;
  padding: 3px 5px;
  background: green;
  text-align: center;
  color: #fff;
  min-width: 50px;
  border-radius: 4px;
  &.color1 {
    background: green;
  }
  &.color2 {
    background: rgb(136, 209, 27);
  }
  &.color3 {
    background: rgb(14, 141, 130);
  }
  &.color4 {
    background: rgb(137, 47, 255);
  }
  &.color5 {
    background: #ccc;
  }
  &.color6 {
    background: rgb(47, 154, 255);
  }
}
.gs_textarea {
  &::v-deep .el-textarea__inner {
    resize: none;
    height: 100px;
    border: 1px solid #ccc;
    outline: none;
    &:focus {
      border-color: #409eff;
    }
  }
}
</style>
